skrilla.controller('addEntityToChargeBackCtrl', function ($scope,
                                                          searchService,
                                                          modalService,
                                                          cacheService,
                                                          currencyService,
                                                          constantsService,
                                                          validationService) {
    $scope.request = {}
    $scope.validate = {};
    $scope.report = cacheService.getObjectOrElse("chargeBackReport", modalService.dismissAll);
    $scope.entityTypes = ["BET", "WITHDRAWAL", "DEPOSIT"];
    $scope.providers = constantsService.getPaymentProviderLabels()


    $scope.reset = function(){
        modalService.confirm("Are you sure you'd like to restart?", function(){
            $scope.request = {}
            $scope.$apply()
        })
    }

    $scope.addEntity = function(){
        if(validate()) {
            modalService.confirm("Are you sure you'd like to add this entity to the Charge Back Report", function () {
                let request = {...$scope.request}
                request.fee = currencyService.multiply($scope.request.fee, $scope.report.currency)
                searchService.post(`chargeBacks/${$scope.report.id}/entity`, request, "Charge back entity created", true)
                    .then(modalService.dismissAll);
            })
        }
    }


    $scope.betTableData = {
        columns: [
            {title: "Bet Name", field: "name"},
            {title: "Entry Id", field: "entryId", filter: {func: (it) => { return `B-${it}`}}},
            {title: "Selection Count", field: "selectionCount"},
            {title: "Stake", field: "stake", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Stake Source", field: "stakeSource"},
            {title: "Odds", field: "odds"},
            {title: "Potential Payout", field: "potentialPayout", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Payout", field: "paidOut", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Winnings", field: "winnings", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Status", field: "status"},
            {title: "Result", field: "result"},
            {title: "Currency", field: "currency"},
            {title: "Rejection Reason", field: "reason"},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Updated At", field: "updatedAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Updated By", field: "updatedBy"}
        ],
        rows: {onClick: clickRow},
        isSkrillaTable: true,
        data: []
    }
    $scope.queryOverride = {
        userId: $scope.report.userId,
        currency: $scope.report.currency,
        providers: {"MERCHANT_WARRIOR": true}, //for deposits, shouldn't affect bets or withdrawals
        showMore: true
    }

    $scope.withdrawalTableData = {
        columns: [
            {title:"Type", field: "externalType"},
            {title:"Full Name", field: "marketingCategory"},
            {title: "Marketing Cat.", field: "marketingCategory"},
            {title: "Status", field: "status"},
            {title: "Requested Amount", field: "requestedAmount", filter: {name: "dollarOrSkrilla", args: [$scope.report.currency, false]}},
            {title: "Paid Amount", field: "paidAmount", filter: {name: "dollarOrSkrilla", args: [$scope.report.currency, false]}},
            {title: "Currency", field: "currency"},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
        ],
        rows: {onClick: clickRow},
        isSkrillaTable: true,
        data: []
    }

    $scope.depositTableData = {
        columns: [
            {title: "Username", field: "username"},
            {title: "Provider", field: "provider", filter: {func: (it) => { return $scope.providers[it]}}},
            {title: "Amount", field: "amount", filter: {name: "dollarOrSkrilla", args: ['currency', true]}},
            {title: "Effective Amount", field: "effectiveAmount", filter: {name: "dollarOrSkrilla", args: ['currency', true]}},
            {title: "Status", field: "status"},
            {title: "Currency", field: "currency"},
            {title: "Updated At", field: "updatedAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}}
        ],
        rows: {onClick: clickRow},
        isSkrillaTable: true,
        data: []
    }

    function getDefaultFee(entity){
        if($scope.request.entityType === "DEPOSIT"){
            return 3500
        }
        else if($scope.request.entityType === "WITHDRAWAL"){
            return entity.paidAmount;
        }
        else{
            return 0
        }
    }

    function clickRow(entity){
        modalService.confirm("Are you sure you'd like to add this entity?", function (){
            $scope.request.entityId = entity.id;
            let fee = getDefaultFee(entity)
            $scope.request.fee = currencyService.divide(fee, $scope.report.currency);
            $scope.$apply()
        })
    }

    function validate(){
        let inputs = [
            validationService.buildFieldValidationObj("fee", !isNaN($scope.request.fee) && validationService.isNotEmpty($scope.request.fee), "Please enter a valid fee"),
            validationService.buildFieldValidationObj("reference", validationService.isNotEmpty($scope.request.reference), "Please enter a valid reference")
        ];
        return validationService.validateForm(inputs, $scope.validate)
    }

});